import {
  AutocompleteArrayInput,
  NumberInput,
  ReferenceArrayInput,
  TextField,
  useGetOne,
} from "react-admin";
import { RecordSummary, MyShow } from "../../ra-lb-tools/components/MyShow";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../../ra-lb-tools/components/myReference";
import { MyList } from "../../ra-lb-tools/components/myList";
import { LabeledColumn } from "../../ra-lb-tools/components/labeledColumn";
import { MyCreate as Create } from "../../ra-lb-tools/components/myMutator";
import { OrganizationField, OrganizationInput } from "./organizations";
import { PlanField, PlanInput } from "./plans";
import { PriceCheck } from "@mui/icons-material";
import {
  MyTabbedShowLayout,
  Tab,
} from "../../ra-lb-tools/components/myTabbedShowLayout";
import { LockerUsageRecordsList } from "./lockerUsageRecord";
import { useParams } from "react-router";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";
import { Debug } from "../../ra-lb-tools/components/debug";
import { Box } from "@mui/material";
import { StripeLink } from "./stripeLink";
import get from "lodash/get";
import { MyDateInput } from "../../ra-lb-tools/components/myDateInput";
import { useWatch, useFormContext } from "react-hook-form";
import { useEffect } from "react";

export const PlanSubscriptionIcon = PriceCheck;

export const PlanSubscriptionList = (props) => (
  <MyList {...props} resource="plan-subscriptions">
    <TextField source="id" />
    <OrganizationField source="organizationId" />
    <PlanField source="planId" />
    <Box source="processorId">
      <TextField source="processorId" />
      <Debug>
        <StripeLink />
      </Debug>
    </Box>
    <MyDateField source="backdateStartDate" showTime />
    <MyDateField source="createdAt" showTime />
    <MyDateField source="updatedAt" showTime />
  </MyList>
);
export const PlanSubscriptionShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <OrganizationField source="organizationId" />
              <PlanField source="planId" />
              <Box source="processorId">
                <TextField source="processorId" />
                <Debug>
                  <StripeLink />
                </Debug>
              </Box>
              <MyDateField source="createdAt" showTime />
              <MyDateField source="updatedAt" showTime />
              <MyDateField source="backdateStartDate" showTime />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Usage Records"
          path="usage-records"
          can={{ action: "list", resource: "locker-usage-records" }}
        >
          <LockerUsageRecordsList filter={{ planSubscriptionId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};

const MinMaxGeneratorsInput = ({ source }) => {
  const planId = useWatch({ name: "planId" });
  const { data: plan, isLoading } = useGetOne(
    "plans",
    { id: planId },
    { enabled: !!planId }
  );

  const { setValue } = useFormContext();

  useEffect(() => {
    if (!plan || plan.type !== "MINMAX") {
      setValue(source, undefined);
    }
  }, [plan, setValue]);

  if (isLoading || !plan) return null;
  if (plan.type !== "MINMAX") return null;

  return (
    <ReferenceArrayInput source={source} reference="min-max-generators">
      <AutocompleteArrayInput
        filterToQuery={(searchText) => ({
          tower_model__name: `${searchText}`,
        })}
      />
    </ReferenceArrayInput>
  );
};

export const PlanSubscriptionCreate = (props) => {
  const transform = (data) => ({
    ...data,
    billingCycleAnchorConfig: data.billingCycleAnchorConfig.dayOfMonth
      ? data.billingCycleAnchorConfig
      : null,
  });

  return (
    <Create {...props} transform={transform}>
      <OrganizationInput
        source="organizationId"
        getOptionDisabled={(org) =>
          !!(!get(org, "customerId") || get(org, "planSubscriptionId"))
        }
      />
      <PlanInput
        source="planId"
        getOptionDisabled={(plan) => !get(plan, "prices.length")}
      />
      <MinMaxGeneratorsInput source="minMaxGenerators" />
      <MyDateInput source="backdateStartDate" />
      <NumberInput
        source="billingCycleAnchorConfig.dayOfMonth"
        defaultValue={1}
      />
    </Create>
  );
};

export const PlanSubscriptionInput = (props) => {
  return (
    <MyReferenceInput
      source="planSubscriptionId"
      reference="plan-subscriptions"
      {...props}
    />
  );
};

export const PlanSubscriptionField = (props) => {
  return (
    <MyReferenceField
      source="planSubscriptionId"
      reference="plan-subscriptions"
      primaryField="id"
      {...props}
    />
  );
};
